import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import { SortableContainer, SortableElement, } from "react-sortable-hoc";
import moment from "moment";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Edit as EditIcon, DeleteOutline as DeleteOutlineIcon, } from '@material-ui/icons';
import AddInteriorItem from './AddInteriorItem'
import { Pagination, STableLoader, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import { checkApiStatus, checkPermission, } from '../../utils_v2';
import { downloadFileType } from "../../../utils";
import { assetTypeValues, backendDateFormat } from "../../../constants";
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { trackActivity } from "../../../utils/mixpanel";
import { getPermissionKey } from "..";
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const interiorInfoObj = {
    item: "",
    description: "",
    remarks: "",
}
const InteriorInfoHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Action(s)</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}
const SortableBodyContainer = SortableContainer(({ interiorInfo, setAddEditInteriorInfo, setDeleteInteriorInfo, params }) => {
    return (
        <TableBody>
            {interiorInfo?.list?.map((item, index) =>
                <InteriorInformationList
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index}
                    item={item}
                    onEdit={() => setAddEditInteriorInfo({ modal: true, data: item })}
                    onDelete={() => setDeleteInteriorInfo({ modal: true, data: item })}
                    params={params}
                />
            )}
        </TableBody>
    );
});

const InteriorInformationList = SortableElement(({ item, onEdit, onDelete, params }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    return (
        <TableRow>
            <TableCell align="left">
                <ul className="list-inline">
                     {checkPermission('technical_specs', getPermissionKey(params.type), 'U') ?
                    <li className="list-inline-item hover-inline" onClick={onEdit}>
                        <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                    </li>:null}
                     {checkPermission('technical_specs', getPermissionKey(params.type), 'U') ?
                    <li className="list-inline-item hover-inline" onClick={onDelete}>
                        <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                    </li>:null}
                </ul>
            </TableCell>
            <TableCell>
                <div style={{ width: '300px' }}>{item?.item || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ width: '300px' }}>{item?.description || '--'}</div>
            </TableCell>
            <TableCell>
                {item?.remarks && item?.remarks?.length > 30 ? (
                    <div style={{ width: '400px' }}>
                        {showMore[item?.field] ? (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
                            </span>
                        ) : (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
                            </span>
                        )}
                    </div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
                )}
            </TableCell>
        </TableRow>
    )
})
const AddEditInteriorCommunication = ({ params, addEditInteriorInfo, toggleModalFn, getResponseBack, assetInfoData }) => {
    const { enqueueSnackbar, } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [interiorInfo, setInteriorInfo] = useState(addEditInteriorInfo?.data);

    const onFieldChange = (key, value) => { setInteriorInfo({ ...interiorInfo, [key]: value }) }
    const onAddEditInteriorInfo = () => {
        let validationInputs={
            item:interiorInfo?.item.trim()? '':'Please enter Item'
        }
        if(Object.keys(validationInputs).every(k=>validationInputs[k]==='')){
        setLoading(true)
        if (interiorInfo.id) {
            globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/interior_config_details/${interiorInfo.id}/`, interiorInfo)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        toggleModalFn(); getResponseBack();
                        trackActivity('Console Management', { data:JSON.stringify(interiorInfo), page_title: 'Interior Information', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Interior Information data from Edit Interior Information form' })
                    }
                    setLoading(false)
                })
        } else {
            globalPostService(`console/v2/asset/${params.type}/${params.aircraft_slug}/interior_config_details/`, interiorInfo)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        trackActivity('Console Management', { data:JSON.stringify(interiorInfo), page_title: 'Interior Information', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added Interior Information data from Add Interior Information form' })
                        toggleModalFn(); getResponseBack();
                    }
                    setLoading(false)
                })
        }
        }else{
            setError(validationInputs)
        }
    }
    return (
        <Dialog
            open={addEditInteriorInfo.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {interiorInfo?.id ? 'Edit ' : 'Add '} Interior Information
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <TextField
                            required
                            name='item'
                            label='Item'
                            value={interiorInfo?.item || ''}
                            fullWidth
                            margin="normal"
                            error={error?.item || false}
                            helperText={error?.item ? error?.item :''}
                            onFocus={()=>{setError({...error, item:''})}}
                            onChange={(e) => onFieldChange('item', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 50 }}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            name='description'
                            label='Description'
                            value={interiorInfo?.description || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('description', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name='remarks'
                            label='Remarks'
                            value={interiorInfo?.remarks || ''}
                            fullWidth
                            multiline
                            rows={3}
                            margin="normal"
                            onChange={(e) => onFieldChange('remarks', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 255 }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditInteriorInfo} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const InteriorInformation = ({ params, assetInfoData }) => {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar, } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [interiorInfo, setInteriorInfo] = useState({ list: [], pagination: null });
    const [addEditInteriorInfo, setAddEditInteriorInfo] = useState({ modal: false, data: null });
    const [deleteInteriorInfo, setDeleteInteriorInfo] = useState({ modal: false, data: null });
    useEffect(() => { getInteriorInfo({per_page:50}, 'skeletonLoader'); }, []);
    const getInteriorInfo = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/interior_config_details/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setInteriorInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteInteriorInfo = () => {
        setLoading(true);
        globalDeleteService(`console/v2/asset/${params.type}/${params.aircraft_slug}/interior_config_details/${deleteInteriorInfo.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteInteriorInfo({ modal: false, data: null });
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getInteriorInfo({per_page: interiorInfo?.pagination?.per_page}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    const onExportInteriorInfo = (type) => {
        setLoading(true);
        let updatedApiUrl;
        let exportName;
        if (type === "sample") {
            const basePath = `console/v2/asset/aircraft/${params.aircraft_slug}/interior_config_details/`;
            updatedApiUrl = `${basePath}?download=xlsx`;
            exportName = `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_Interior_Information ${moment().format(backendDateFormat)}_sample`
        } else {
            updatedApiUrl = `console/v2/asset/aircraft/${params.aircraft_slug}/interior_config_details/export/`;
            exportName = `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_Interior_Information ${moment().format(backendDateFormat)}`
        }
        globalExportService(updatedApiUrl)
            .then(response => {
                downloadFileType(response, exportName, 'xlsx')
                trackActivity('Console Management', { page_title: 'Interior Information', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Exported', event_desc: `Interior Information Exported Successfully`, file_extension: 'xlsx' })
                setLoading(false)
            });
    }

    return (
        <div style={{ padding: '10px' }}>
            {skeletonLoader ? <STableLoader count={7} size={7} /> :
                <>
                    <AddInteriorItem
                        addPermission={checkPermission('technical_specs', getPermissionKey(params.type), 'C') || false}
                        exportPermission={true}
                        onAddItem={() => setAddEditInteriorInfo({ modal: true, data: interiorInfoObj })}
                        isExport
                        isImport
                        item={interiorInfo}
                        isSampleExport={true}
                        onExport={onExportInteriorInfo}
                        getResponseBack={() => getInteriorInfo({}, 'skeletonLoader')}
                        trackActivity={trackActivity('Console Management', { page_title: 'Interior & Information', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Imported', event_desc: `Interior Information Imported Successfully`, file_extension: 'xlsx' })}
                        url={`/console/v2/asset/aircraft/${params.aircraft_slug}/interior_config_details/import/`}
                    />
                    <Paper square>
                        <div style={{height:`${(window.innerHeight -  (interiorInfo?.list?.length ? 330 : 280)) - navTitleOffset}px`,overflow:'auto'}}>
                        <Table className='mui-table-format' stickyHeader>
                            <InteriorInfoHd />
                            <SortableBodyContainer
                                useDragHandle
                                interiorInfo={interiorInfo}
                                setAddEditInteriorInfo={setAddEditInteriorInfo}
                                setDeleteInteriorInfo={setDeleteInteriorInfo}
                                params={params}
                            />
                        </Table>
                        {!interiorInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    {interiorInfo?.pagination ?
                        <Paper square>
                            <Pagination
                                pagination={interiorInfo.pagination}
                                onChangePage={(event, newPage) => getInteriorInfo({ ...filter, page: newPage + 1, per_page: interiorInfo.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getInteriorInfo({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                        : null
                    }
                </>
            }
            {addEditInteriorInfo.modal ?
                <AddEditInteriorCommunication
                    params={params}
                    assetInfoData={assetInfoData}
                    addEditInteriorInfo={addEditInteriorInfo}
                    toggleModalFn={() => setAddEditInteriorInfo({ modal: false, data: null })}
                    getResponseBack={() => getInteriorInfo({per_page: interiorInfo?.pagination?.per_page}, 'pageLoader')}
                /> : null
            }
            {deleteInteriorInfo.modal ?
                <DeletePopUp
                    modal={deleteInteriorInfo.modal}
                    title='Delete Interior Information'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteInteriorInfo({ modal: false, data: null })}
                    deleteRecordFn={onDeleteInteriorInfo}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(InteriorInformation);
